import { Component, Host, h, Prop, State, Listen, Element } from '@stencil/core';
import { TimingFunction } from './types';

/**
 * DEPRECATED: Do not use
 * see https://big.aha.io/develop/features/A-16980
 */
export interface AhaFadeOut extends HTMLAhaFadeOutElement {}

/**
 * @slot DEFAULT - Contents that are in the area that will fade out.
 */
@Component({
  tag: 'aha-fade-out',
  styleUrl: 'aha-fade-out.css',
  shadow: true,
})
export class AhaFadeOut {
  @Element() private host!: HTMLAhaFadeOutElement;

  /** Amount of time (in seconds) the animation should take. */
  @Prop({ reflect: true }) duration: number = 0.5;

  /** Amount of time (in seconds) to wait before the fade animation begins. */
  @Prop({ reflect: true }) delay: number = 0;

  /** The timing function to use for the animation. */
  @Prop({ reflect: true }) timingFunction: TimingFunction = 'ease-in';

  /** Whether or not the element will have a `hidden` attribute set when the animation finishes. This effectively removes it from the DOM. */
  @Prop({ reflect: true }) willDisappear: boolean = false;

  /** An animation will not start unless paused is `false`. */
  @Prop({ reflect: true }) paused: boolean = false;

  @State() ariaHiddenState: boolean = false;

  @Listen('animationend')
  animationendHandler(event: Event) {
    this.ariaHiddenState = true;
  }

  render() {
    return (
      <Host
        style={{
          '--aha-fade-out--delay': `${this.delay}s`,
          '--aha-fade-out--duration': `${this.duration}s`,
          '--aha-fade-out--timing-function': this.timingFunction,
        }}
        aria-hidden={this.ariaHiddenState}
        hidden={this.willDisappear && this.ariaHiddenState}
      >
        <slot></slot>
      </Host>
    );
  }
}
